module.exports = __webpack_public_path__ + "img/bg.36f09c82.png";